import sls_es_comissao_notasRouter from './sls_es_comissao_notas.router';

export default [
  ...sls_es_comissao_notasRouter,
];
